import { render } from "./TnC.vue?vue&type=template&id=046a4036&scoped=true"
import script from "./TnC.vue?vue&type=script&lang=js"
export * from "./TnC.vue?vue&type=script&lang=js"

import "./TnC.vue?vue&type=style&index=0&id=046a4036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046a4036"]])

export default __exports__